import axios from 'axios';
import dayjs from 'dayjs';
import { tokenDataHelper, userDataHelper } from './localStorageHelper';

declare global {
    interface Window {
        env: {
            API_DOMAIN_ADDR: string;
        };
    }
}
const target = window.env && window.env.API_DOMAIN_ADDR;

axios.interceptors.request.use(async (request: any) => {
    const { token, token_expiry_date } = tokenDataHelper.getTokenData();
    if (token && !request.url?.includes('/login/refresh')) {
        request.headers['Authorization'] = token;

        // Check if the token has expired using dayjs
        const isTokenExpired = dayjs().isAfter(dayjs(token_expiry_date));

        if (isTokenExpired) {
            userDataHelper.removeUserData();
            tokenDataHelper.removeTokenData();
            window.location.replace('/sign-in');
        }
    }
    return request;
});

axios.defaults.baseURL = target;

export default axios;

